const tagIncrementAmountIfExistsInTags = (tags, tagToSearch) => {
  const defaultValueOfTheIncreaseAmountTag = 1;

  if (!tags) {
    return defaultValueOfTheIncreaseAmountTag;
  }

  const ExpReg = new RegExp(`${tagToSearch}([^,]+),?|$`);
  const foundTag = tags.match(ExpReg);

  if (!foundTag || foundTag.length < 2)
    return defaultValueOfTheIncreaseAmountTag;

  const tagValue = foundTag[1];
  const numberTagValue = Number(tagValue);
  const valueIsNaN = Number.isNaN(numberTagValue);

  if (valueIsNaN) {
    return defaultValueOfTheIncreaseAmountTag;
  }

  return numberTagValue;
};

export default tagIncrementAmountIfExistsInTags;
